import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

class MobileSearchClose extends Component {
  constructor(props) {
    super(props);

  }
  render() {
    if (this.props.device !== "desktop") {
      return (
        <div className="kilo children-search__close">
          <a href="" onClick={(e) => {
              this.props.toggleSearch(e);
            }}>
            <FontAwesomeIcon icon={faTimes} />
          </a>
        </div>
      );
    }
    return false;
  }
}
export default MobileSearchClose;